import { render, staticRenderFns } from "./NavbarGroup.vue?vue&type=template&id=7c64edef"
import script from "./NavbarGroup.vue?vue&type=script&lang=ts"
export * from "./NavbarGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports